import React from "react";
import { CSSTransition } from "react-transition-group";
import { TrainingCenterBundleItemVideoMediaOverlay } from "../../../system/AppState/AppStateTrainingCenter";
import { TrainingCenterLanguagePreference } from "../TrainingCenterLanguageLookup";
import TrainingCenterVideoMediaOverlay from "./TrainingCenterVideoMediaOverlay";

function isMediaOverlayInRange(
  currentSecond: number,
  { atSecond, duration }: TrainingCenterBundleItemVideoMediaOverlay
) {
  const hasOverlayStarted = atSecond <= currentSecond;
  const hasOverlayEnded = atSecond + duration <= currentSecond;

  return hasOverlayStarted && !hasOverlayEnded;
}

interface Props {
  currentSecond: number;
  mediaOverlay: TrainingCenterBundleItemVideoMediaOverlay;
  languagePreference: TrainingCenterLanguagePreference;
  images: Map<string, HTMLImageElement> | undefined;
}

const TrainingCenterVideoMediaOverlayWrapper = (props: Props) => {
  const isOverlayInRange = React.useMemo(
    () => isMediaOverlayInRange(props.currentSecond, props.mediaOverlay),
    [props.currentSecond, props.mediaOverlay]
  );

  return (
    <>
      <CSSTransition
        in={isOverlayInRange}
        timeout={250}
        classNames="TrainingCenterVideoMediaOverlay"
        unmountOnExit={true}
      >
        <TrainingCenterVideoMediaOverlay
          images={props.images}
          mediaOverlay={props.mediaOverlay}
          languagePreference={props.languagePreference}
        />
      </CSSTransition>
    </>
  );
};

export default React.memo(TrainingCenterVideoMediaOverlayWrapper);
